export default "__VITE_ASSET__DuJ2bF2b__"